import React from "react";
import { IconProps } from "../icon";

export const CheckSentIcon = ({ size = "24px", color = "#000", ...props }: IconProps<string, string>) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path stroke={color || "#000"} strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 7l-9 10-4-4" />
  </svg>
);
